// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gnZ3","toggle":"styles_toggle__3M3LH","preview":"styles_preview__1ajgm"};